import React, { useEffect, useState } from 'react';
import { ResponsiveChoropleth } from '@nivo/geo';

import {geoFeatures} from '../../../../Charts/geoFeatureData';
// import {mockGeographyData as data} from './geoData';
import LoadingScreen from '../../../../../LoadingScreen';



const GeographyMap = ({data}) => {
  const [loading,setLoading] = useState();
  const [domain,setDomain] = useState();
  const [formattedData,setFormattedData] = useState(null);
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    console.log(data)
    const values = data.map((country) => country.totalTickets);
    const minValue = Math.min(...values);
    const maxValue = Math.max(...values);

    setDomain([minValue, maxValue]);

    setFormattedData(data.map(item => ({
      id: item._id, 
      value: item.totalTickets,
    })));
  }, []);

  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div style={{ height: '25vh', width: '100%' }}>
          <h4 style={{ marginTop: '-5em', marginBottom:"0.3em" }}>Geographic Distribution of Customers
</h4>
          <ResponsiveChoropleth
            data={formattedData}
            colors="nivo"
            features={geoFeatures.features}
            margin={{ top: 100, right: 0, bottom: 0, left: 0 }}
            domain={domain}
            unknownColor="#666666"
            label="properties.name"
            valueFormat=".2s"
            projectionScale={isMobile? 110 : 150}
            projectionTranslation={[0.5, 0.5]}
            projectionRotation={[0, 0, 0]}
            borderWidth={1.5}
            borderColor="#ffffff"
            legends={[
              {
                anchor: 'top-right',
                direction: 'column',
                justify: true,
                translateX: -20,
                translateY: -80,
                itemsSpacing: 0,
                itemWidth: 94,
                itemHeight: 18,
                itemDirection: 'left-to-right',
                itemTextColor: 'black',
                itemOpacity: 0.85,
                symbolSize: 18,
                effects: [
                  {
                    on: 'hover',
                    style: {
                      itemTextColor: '#454545',
                      itemOpacity: 1,
                    },
                  },
                ],
              },
            ]}
          />
        </div>
      )}
    </div>
  );
};

export default GeographyMap;
